import getStepType from "./stepTypes";

export function stepCanHavePermissions(step) {
  return !!getStepType(step?.type)?.canHavePermissions;
}
